export default defineNuxtPlugin(async () => {
    const userStore = useUserStore();
    
    // Инициализируем store только на клиенте
    /* if (process.client) {
        await userStore.init();
    } */
}); 